import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./Rubric.css";
import { RUBRICS, TEMPLATES } from "config/constants/editor";

export default function Rubric(props) {
  if (props.template !== TEMPLATES.DEFAULT) {
    return (
      <div className={classNames(styles.root, styles[props.template.type])}>
        {props.template.name}
      </div>
    );
  }

  if (props.rubric === RUBRICS.DEFAULT) {
    return null;
  }

  return (
    <div
      className={styles.root}
      style={{ color: `#${props.rubric.hex_color}` }}
    >
      {props.rubric.name}
    </div>
  );
}

Rubric.propTypes = {
  rubric: PropTypes.object,
  template: PropTypes.object,
};
